import { selectAliasedEntity, selectEntity } from "state/selectors/data";
import { selectRouteParam } from "state/selectors/router";

export function selectCurrentLanguages(state) {
    const websiteId = selectRouteParam(state, "service");
    if (!websiteId) return [];
    return selectLanguages(state, websiteId);
}

export function selectLanguages(state, websiteId) {
    const website = selectAliasedEntity(state, "console.services", websiteId);
    const cmsId = website.content_source;
    if (!cmsId) return [];
    const cms = selectEntity(state, "console.services.cms", cmsId);
    const languages = cms?.languages || [];
    return languages
        .map((lang) => {
            return selectEntity(
                state,
                "schema.data.value",
                `data.languages.${lang}`
            );
        })
        .map((lang) => ({
            ...lang,
            id: lang.value,
        }));
}
